import { useEffect, useId, useRef } from 'react';
import { isPreviewImage, saveLoadedFile, type LoadedFile } from '../../client/chat/common/files';
import { canShowPdf, PdfPages } from '../../components/Pdf';
import { useToast } from '../../lib/toast';

// Datei aus dem Chat ansehen (Kanzlei): Fenster mit Vorschau, „Herunterladen“ und „Schließen“.
export function FileDialog({
  file,
  clientName,
  onClose,
}: {
  file: LoadedFile & { meta: string };
  clientName: string;
  onClose(): void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  const toast = useToast();
  const name = file.file.name;

  useEffect(() => {
    const d = ref.current;
    if (d && !d.open) d.showModal();
  }, []);

  return (
    <dialog
      ref={ref}
      className="chat-view"
      aria-labelledby={titleId}
      onClose={onClose}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
    >
      <div className="lv-h">
        <b id={titleId}>{file.meta}</b>
        <span className="note">
          {name} · {clientName}
        </span>
        <button
          type="button"
          className="btn sm"
          onClick={() => {
            saveLoadedFile(file);
            toast('Datei gespeichert');
          }}
        >
          Herunterladen
        </button>
        <button type="button" className="btn sm dark" onClick={onClose}>
          Schließen
        </button>
      </div>
      {isPreviewImage(file.file.mime) ? (
        <div className="lv-b">
          <img src={file.url} alt={name} />
        </div>
      ) : file.file.mime === 'application/pdf' && canShowPdf() ? (
        <object data={file.url} type="application/pdf" className="lv-b" aria-label={name}>
          <p className="note chat-nopdf">Die PDF kann hier nicht angezeigt werden. Bitte herunterladen.</p>
        </object>
      ) : file.file.mime === 'application/pdf' ? (
        <div className="lv-b">
          <PdfPages
            url={file.url}
            title={name}
            fallback={<p className="note chat-nopdf">Die PDF kann hier nicht angezeigt werden. Bitte herunterladen.</p>}
          />
        </div>
      ) : (
        <div className="lv-b chat-lv-none">
          <p className="note chat-nopdf">Die Datei kann hier nicht angezeigt werden. Bitte herunterladen.</p>
        </div>
      )}
    </dialog>
  );
}
